// Add base url when debugging frontend on local
// export const API_BASE_URL = "http://localhost:8090/";
export const SELECTED_COUNTRY = 'SELECTED_COUNTRY'
export const COUNTRIES = 'COUNTRIES'
export const RESET = 'RESET'
export const REF_DATA = 'REF_DATA'
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE'
export const ASSISTANT_ENABLED = 'ASSISTANT_ENABLED'
export const ABBVIE_EMPLOYEE = 'ABBVIE_EMPLOYEE'
export const HCP = 'HCP'
export const PATIENT = 'PATIENT'
export const JWT_TOKEN = 'jwtToken'
export const NO_NAME_DISPLAYED = '  '
export const DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON'
export const LINK_BUTTON = 'LINK_BUTTON'
export const Timeout = 1800000
export const DISABLE_MODAL_PATHS = ['/conference', '/scibooth', '/country-not-available']
export const DISABLE_MODAL_PATHS_INCLUDING_ERROR_PATH = DISABLE_MODAL_PATHS.concat('/errorPage', '/errorpage')
export const ADDRESS_FIELD_NAMES = ['street', 'city', 'state', 'postalCode']
export const REQUESTOR_FIELD_NAMES = ADDRESS_FIELD_NAMES.concat(
  ['title', 'firstname', 'lastname', 'email', 'phone', 'extn', 'userType',
    'medicalSpeciality', 'affiliation', 'hcpLicenseNumber'])

export const FOLLOWUP_REQUIRED = 'Follow up required'
export const NOFOLLOWUP_REQUIRED = 'No follow up required'
export const RESPONDED_WITH = 'Responded With : '
export const NEW_LINE = '\n'

export const REPORT_TYPES = [
  {
    value: 'ALLERGEN_DOWNLOAD',
    label: 'Allergen Download'
  },
  {
    value: 'ALLERGEN_CHECK',
    label: 'Allergen Search'
  },
  {
    value: 'KEYWORD_SEARCH',
    label: 'Keyword Search'
  },
  {
    value: 'DOCUMENT_DOWNLOAD',
    label: 'Document Downloads'
  },
  {
    value: 'COUNTRYWISE',
    label: 'All Results by Keyword Search'
  },
  {
    value: 'MSL_MEETING_REQUEST',
    label: 'MSL Meeting Requests'
  }
]

export const REPORTING_PERIODS = [
  {
    value: 'TODAY',
    label: 'Today'
  },
  {
    value: 'WEEKLY',
    label: 'Weekly'
  }, {
    value: 'MONTHLY',
    label: 'Monthly'
  }, {
    value: 'YEARLY',
    label: 'Yearly'
  }
]

export const sitePermissionsNav = {
   "About us": 'ABOUT_US',
  "Admin": 'ADMIN',
  "Allergen": 'ALLERGEN',
  "Temperature Excursion Tool": 'CALCULATOR',
  "Congresses": 'CONGRESSINTEGRATION',
  "Find My MSL": 'FINDMYMSL',
  "Reports": 'REPORT',
  "Search": 'SEARCH',
  "Products": 'PRODUCTS',
  "HCP Resources": 'SITERESOURCES',
  "Submit Inquiry": 'SUBMIT'}

export class Navigation {
    static Keys = {
      HOME: 'HOME',
      ABOUTUS: 'ABOUTUS',
      SUBMIT: 'SUBMIT',
      SEARCH: 'SEARCH',
      ALLERGEN: 'ALLERGEN',
      PRODUCTS: 'PRODUCTS',
      STABTOOL: 'STABTOOL',
      FINDMYMSL: 'FINDMYMSL',
      SITERESOURCES: 'SITERESOURCES',
      CONGRESSINTEGRATION: 'CONGRESSINTEGRATION',
      REPORT: 'REPORT',
      ADMIN: 'ADMIN',
      
    }
}

export const ANALYTICS_LINK_TYPES = {
  CUSTOM_LINK: 'o',
  DOWNLOAD_LINK: 'd',
  EXIT_LINK: 'e'
}

export const ANALYTICS_LINK_SECTIONS = {
  ASSISTANT: 'Assistant: ',
  NAV: 'Navigation: '
}

export const ENABLED_COUNTRIES = [
  'United States',
  'American Samoa',
  'Virgin Islands, U.S.',
  'Palau',
  'Micronesia, Federated States of',
  'United States Minor Outlying Islands',
  'Northern Mariana Islands',
  'Puerto Rico',
  'Marshall Islands',
  'Guam'
]

export const SITE_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'pl', label: 'Polski' },
  { value: 'pt', label: 'Português' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'ch', label: 'Chinese'},
  { value: 'ja', label: 'Japanese'}
]

export const GERMANY_PP_SITE_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
]

export const SITE_LANGUAGES_ENGLISH = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'pl', label: 'Polish' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'es', label: 'Spanish' },
  { value: 'tr', label: 'Turkish' },
  { value: 'ch', label: 'Chinese'},
  { value: 'ja', label: 'Japanese'}
]

export const TABLE_HEADER_COLUMN_NO_SORT = 'No Sort'

export const PERMISSIONS = {
  ABOUT_US: 'ABOUT_US',
  ADMIN: 'ADMIN',
  ASSISTANT: 'ASSISTANT',
  ALLERGEN: 'ALLERGEN',
  CALCULATOR: 'CALCULATOR',
  CONGRESSINTEGRATION: 'CONGRESSINTEGRATION',
  FINDMYMSL: 'FINDMYMSL',
  NONE: 'NONE',
  PUBLIC: 'PUBLIC',
  REPORT: 'REPORT',
  SEARCH: 'SEARCH',
  PRODUCTS: 'PRODUCTS',
  SCI_BOOTH: 'SCI_BOOTH',
  SITERESOURCES: 'SITERESOURCES',
  SUBMIT: 'SUBMIT'
}

export const USER_SCOPE = {
  ABBVIE_EMPLOYEE: 'Internal',
  HCP: 'External',
  PATIENT: 'External Patient'
}

export const RESPONSIVE_BREAKPOINTS = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px'
}



// WEBPACK FOOTER //
// ./src/constants.js